import { Store } from '@/core/flux.service';
import type { PersistenceLevel } from '@/core/flux.service';

interface VantageTrendState {
  quickTrendOpen: boolean;
  isSingleAxis: boolean;
  ganttShowAll: boolean;
  showContextCapsules: boolean;
}

export type VantageTrendDehydratedState = VantageTrendState;

export class VantageTrendStore extends Store {
  persistenceLevel: PersistenceLevel = 'WORKSHEET';
  static readonly storeName = 'sqVantageTrendStore';

  initialize(): void {
    const initialState: VantageTrendState = {
      quickTrendOpen: false,
      isSingleAxis: true,
      ganttShowAll: false,
      showContextCapsules: false,
    };
    this.state = this.immutable(initialState);
  }

  get quickTrendOpen(): boolean {
    return this.state.get('quickTrendOpen');
  }

  get isSingleAxis(): boolean {
    return this.state.get('isSingleAxis');
  }

  get ganttShowAll(): boolean {
    return this.state.get('ganttShowAll');
  }

  get showContextCapsules(): boolean {
    return this.state.get('showContextCapsules');
  }

  dehydrate(): VantageTrendDehydratedState {
    return this.state.serialize();
  }

  rehydrate(dehydratedState: Partial<VantageTrendDehydratedState>): void {
    this.state.merge(dehydratedState);
  }

  protected readonly handlers = {
    SET_VANTAGE_QUICK_TREND_OPEN: (payload: { isOpen: boolean }): void =>
      this.state.set('quickTrendOpen', payload.isOpen),
    SET_VANTAGE_TREND_SINGLE_AXIS: (payload: { isSingleAxis: boolean }): void =>
      this.state.set('isSingleAxis', payload.isSingleAxis),
    SET_VANTAGE_GANTT_SHOW_ALL: (payload: { showAll: boolean }): void =>
      this.state.set('ganttShowAll', payload.showAll),
    SET_VANTAGE_SHOW_CONTEXT_CAPSULES: (payload: { showContextCapsules: boolean }) =>
      this.state.set('showContextCapsules', payload.showContextCapsules),
  };
}
